import CityPageTemplate from "../city-template/CityPageTemplate";
import { doverDeConfig } from "./data";

export default function DoverDePage() {
  return <CityPageTemplate config={doverDeConfig} />;
}